"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EquippableItemClassesWithWeapons = exports.EquippableItemClasses = exports.GivesBonusInHandItemClasses = exports.EquipHash = exports.PotionClasses = exports.EarClasses = exports.HandsClasses = exports.FeetClasses = exports.RingClasses = exports.WristsClasses = exports.WaistClasses = exports.NeckClasses = exports.HeadClasses = exports.RobeClasses = exports.ArmorClasses = exports.ShieldClasses = exports.WeaponClasses = exports.SharpWeaponClasses = exports.TrinketClasses = exports.AmmoClasses = exports.ItemClass = exports.MiscClass = exports.ArmorClass = exports.WeaponClass = exports.MagicClasses = void 0;
const building_blocks_1 = require("./building-blocks");
exports.MagicClasses = {
    physical: false,
    necrotic: true,
    fire: true,
    ice: true,
    lightning: true,
    water: true,
    energy: true,
    poison: true,
    disease: true,
    acid: false,
    sonic: false,
    blunt: false,
    sharp: false,
};
var WeaponClass;
(function (WeaponClass) {
    WeaponClass["Arrow"] = "Arrow";
    WeaponClass["Axe"] = "Axe";
    WeaponClass["Blunderbuss"] = "Blunderbuss";
    WeaponClass["Broadsword"] = "Broadsword";
    WeaponClass["Club"] = "Club";
    WeaponClass["Crossbow"] = "Crossbow";
    WeaponClass["Dagger"] = "Dagger";
    WeaponClass["Flail"] = "Flail";
    WeaponClass["Greataxe"] = "Greataxe";
    WeaponClass["Greatmace"] = "Greatmace";
    WeaponClass["Greatsword"] = "Greatsword";
    WeaponClass["Halberd"] = "Halberd";
    WeaponClass["Hammer"] = "Hammer";
    WeaponClass["Longbow"] = "Longbow";
    WeaponClass["Longsword"] = "Longsword";
    WeaponClass["Mace"] = "Mace";
    WeaponClass["Saucer"] = "Saucer";
    WeaponClass["Shield"] = "Shield";
    WeaponClass["Shortbow"] = "Shortbow";
    WeaponClass["Shortsword"] = "Shortsword";
    WeaponClass["Spear"] = "Spear";
    WeaponClass["Staff"] = "Staff";
    WeaponClass["Sword"] = "Sword";
    WeaponClass["Throwing"] = "Throwing";
    WeaponClass["Totem"] = "Totem";
    WeaponClass["TwoHanded"] = "TwoHanded";
    WeaponClass["Wand"] = "Wand";
})(WeaponClass || (exports.WeaponClass = WeaponClass = {}));
var ArmorClass;
(function (ArmorClass) {
    ArmorClass["Amulet"] = "Amulet";
    ArmorClass["Bracers"] = "Bracers";
    ArmorClass["Boots"] = "Boots";
    ArmorClass["Breastplate"] = "Breastplate";
    ArmorClass["Claws"] = "Claws";
    ArmorClass["Cloak"] = "Cloak";
    ArmorClass["Earring"] = "Earring";
    ArmorClass["Fullplate"] = "Fullplate";
    ArmorClass["Fur"] = "Fur";
    ArmorClass["Gloves"] = "Gloves";
    ArmorClass["Hat"] = "Hat";
    ArmorClass["Helm"] = "Helm";
    ArmorClass["Robe"] = "Robe";
    ArmorClass["Ring"] = "Ring";
    ArmorClass["Sash"] = "Sash";
    ArmorClass["Scaleplate"] = "Scaleplate";
    ArmorClass["Skull"] = "Skull";
    ArmorClass["Tunic"] = "Tunic";
    ArmorClass["Trinket"] = "Trinket";
})(ArmorClass || (exports.ArmorClass = ArmorClass = {}));
var MiscClass;
(function (MiscClass) {
    MiscClass["Book"] = "Book";
    MiscClass["Bottle"] = "Bottle";
    MiscClass["Box"] = "Box";
    MiscClass["Coin"] = "Coin";
    MiscClass["Corpse"] = "Corpse";
    MiscClass["Flower"] = "Flower";
    MiscClass["Food"] = "Food";
    MiscClass["Gem"] = "Gem";
    MiscClass["Hands"] = "Hands";
    MiscClass["Key"] = "Key";
    MiscClass["Rock"] = "Rock";
    MiscClass["Scale"] = "Scale";
    MiscClass["Scroll"] = "Scroll";
    MiscClass["Trap"] = "Trap";
    MiscClass["TrapSet"] = "TrapSet";
    MiscClass["Twig"] = "Twig";
})(MiscClass || (exports.MiscClass = MiscClass = {}));
exports.ItemClass = Object.assign({}, WeaponClass, ArmorClass, MiscClass);
exports.AmmoClasses = [exports.ItemClass.Arrow, exports.ItemClass.Wand];
exports.TrinketClasses = [exports.ItemClass.Trinket];
exports.SharpWeaponClasses = {
    [exports.ItemClass.Axe]: true,
    [exports.ItemClass.Blunderbuss]: true,
    [exports.ItemClass.Broadsword]: true,
    [exports.ItemClass.Crossbow]: true,
    [exports.ItemClass.Dagger]: true,
    [exports.ItemClass.Greataxe]: true,
    [exports.ItemClass.Greatsword]: true,
    [exports.ItemClass.Halberd]: true,
    [exports.ItemClass.Longbow]: true,
    [exports.ItemClass.Longsword]: true,
    [exports.ItemClass.Shortbow]: true,
    [exports.ItemClass.Shortsword]: true,
    [exports.ItemClass.Spear]: true,
};
exports.WeaponClasses = Object.values(WeaponClass);
exports.ShieldClasses = [exports.ItemClass.Shield, exports.ItemClass.Saucer];
exports.ArmorClasses = [
    exports.ItemClass.Tunic,
    exports.ItemClass.Breastplate,
    exports.ItemClass.Fur,
    exports.ItemClass.Fullplate,
    exports.ItemClass.Scaleplate,
];
exports.RobeClasses = [exports.ItemClass.Cloak, exports.ItemClass.Robe];
exports.HeadClasses = [
    exports.ItemClass.Hat,
    exports.ItemClass.Helm,
    exports.ItemClass.Skull,
    exports.ItemClass.Saucer,
];
exports.NeckClasses = [exports.ItemClass.Amulet];
exports.WaistClasses = [exports.ItemClass.Sash];
exports.WristsClasses = [exports.ItemClass.Bracers];
exports.RingClasses = [exports.ItemClass.Ring];
exports.FeetClasses = [exports.ItemClass.Boots];
exports.HandsClasses = [
    exports.ItemClass.Gloves,
    exports.ItemClass.Claws,
    exports.ItemClass.Hands,
];
exports.EarClasses = [exports.ItemClass.Earring];
exports.PotionClasses = [exports.ItemClass.Bottle];
exports.EquipHash = {};
exports.ArmorClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Armor));
exports.RobeClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Robe));
exports.HeadClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Head));
exports.NeckClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Neck));
exports.WaistClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Waist));
exports.WristsClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Wrists));
exports.RingClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Ring));
exports.FeetClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Feet));
exports.HandsClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Hands));
exports.EarClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Ear));
exports.PotionClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Potion));
exports.AmmoClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Ammo));
exports.TrinketClasses.forEach((t) => (exports.EquipHash[t] = building_blocks_1.ItemSlot.Trinket));
exports.GivesBonusInHandItemClasses = [
    ...Object.keys(WeaponClass),
    ...exports.NeckClasses,
];
exports.EquippableItemClasses = [
    ...exports.ArmorClasses,
    ...exports.RobeClasses,
    ...exports.HeadClasses,
    ...exports.NeckClasses,
    ...exports.WaistClasses,
    ...exports.WristsClasses,
    ...exports.RingClasses,
    ...exports.FeetClasses,
    ...exports.HandsClasses,
    ...exports.EarClasses,
    ...exports.TrinketClasses,
];
exports.EquippableItemClassesWithWeapons = [
    ...Object.keys(WeaponClass),
    ...exports.AmmoClasses,
];
